"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const honest_react_1 = require("@digitools/honest-react");
const LoadingScreen = () => ((0, jsx_runtime_1.jsx)("main", { children: (0, jsx_runtime_1.jsx)(honest_react_1.Spinner, { isShown: true }) }));
exports.default = LoadingScreen;
